// src/firebase.js
import { initializeApp } from "firebase/app"
import { getMessaging, getToken, onMessage } from "firebase/messaging"

const firebaseConfig = {
  apiKey: "AIzaSyCdZ9qrMOBRexL-cIP7kUkthKeHfZugv3o",
  authDomain: "ecsinternational-8445a.firebaseapp.com",
  databaseURL: "https://ecsinternational-8445a-default-rtdb.firebaseio.com",
  projectId: "ecsinternational-8445a",
  storageBucket: "ecsinternational-8445a.firebasestorage.app",
  messagingSenderId: "260032370320",
  appId: "1:260032370320:web:b240cd8037e96b55ceaa15",
}

const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)

export { messaging, getToken, onMessage }
